'use strict';
const traverse = require('./traverse');
module.exports = function flattenIdeas(contentObjectOrArray) {
	const flatIdeas = [];
	if (Array.isArray(contentObjectOrArray)) {
		contentObjectOrArray.forEach(idea => traverse(idea, subIdea => flatIdeas.push(subIdea)));
	} else {
		traverse(contentObjectOrArray, subIdea => flatIdeas.push(subIdea));
	}
	return flatIdeas;
};
